import React from "react";
type SectionHeadingProps = {
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: "dark" | "light";
};
export function SectionHeading({
  title,
  intro,
  tone = "dark"
}: SectionHeadingProps) {
  const isDark = tone === "dark";
  return <div className="mx-auto mb-10 max-w-3xl text-center" data-id="element-253" data-mp="3f2wwpkj9gxw6">
      <h2 className={`font-display text-[34px] font-extrabold uppercase leading-[1.02] sm:text-5xl ${isDark ? "text-white" : "text-ink"}`} data-id="element-254" data-mp="3jzdnynlrbsdh">
        {title}
      </h2>
      {intro && <div className={`mt-4 text-[17px] leading-relaxed ${isDark ? "text-mist" : "text-slate-600"}`} data-id="element-255" data-mp="gix2hgsgaua3">{intro}</div>}
    </div>;
}